import React from "react";

import ExternalLink from "../generic/externalLink";

const NavBarLink = ({ id, href, title, onClick, defaultMessage }) => (
  <ExternalLink
    id={id}
    href={href}
    title={title}
    onClick={onClick}
    defaultMessage={defaultMessage}
    className="external-link navbar-link"
  />
);

export default NavBarLink;
